<div ngbDropdown container="body">
  <button id="service-action-menu"
          [disabled]="isDisableActionMenu"
          (click)="onOpenActionMenu();$event.stopPropagation();"
          ngbDropdownToggle>
    <bringoz-icon iconName="menu"></bringoz-icon>
  </button>
  <div ngbDropdownMenu aria-labelledby="service-action-menu">

    <ng-container *ngFor="let action of actions">
      <button
              ngbDropdownItem
              type="tertiary"
              appBringozIdGenerator="{{action.id}}"
              *ngxPermissionsOnly="action.permission"
              (click)="onActionSelect(action.id, $event)">
        <div class="layout-row layout-align-start-center">
          <bringoz-icon [iconName]="action.icon" [classSize]="'xl'" class="gray-102"></bringoz-icon>
          <span class="br-body-2 margin-left-10">{{'SERVICE_ACTION_MENU.' + action.title | translate}}</span>
        </div>
      </button>
    </ng-container>

    <ng-container  *ngFor="let action of extraActions">
      <button
              ngbDropdownItem
              type="tertiary"
              appBringozIdGenerator="{{action.id}}"
              *ngxPermissionsOnly="action.permission"
              (click)="onExtraActionSelect(action.id, $event)">
        <div class="layout-row layout-align-start-center">
          <bringoz-icon [iconName]="action.icon" [classSize]="'xl'" class="gray-102"></bringoz-icon>
          <span class="br-body-2 margin-left-10">{{'SERVICE_ACTION_MENU.' + action.title | translate}}</span>
        </div>
      </button>
    </ng-container>

  </div>
</div>
